import {Service} from "../Service";

export class PlanConvenioService extends Service {
    constructor() {
        super('planConvenio/');
    }

    obtenerCuentasConPlan(params, config) {
        this.onStart();
        return this.http.get(this.getUrl(['obtener', 'cuentas', 'conPlan'], params), config)
            .then((response) => this.onData(response))
            .then((response) => this.onData(response))
            .catch((e) => {
                this.onError(e);
                this.data = {data: []};
                this.loading = false;
            })
            .finally(() => {
                this.onFinaly();
            })
    }

    traerDatosPortalLinea(datos) {
        this.onStart();
        return this.http.post(this.getUrl(['traerPortal', 'linea']), datos)
            .then((response) => this.onData(response))
            .then((response) => this.onData(response))
            .catch((e) => {
                this.onError(e);
                this.data = {data: []};
                this.loading = false;
            })
            .finally(() => {
                this.onFinaly();
            })
    }

    guardarPortalLinea(portalLinea) {
        this.onStart();
        return this.http.post(this.getUrl(['portal', 'linea']), portalLinea)
            .then((response) => this.onData(response))
            .then((response) => this.onData(response))
            .catch(() => {
                throw new Error('Error al guardar los datos')
            })
            .finally(() => {
                this.onFinaly();
            })
    }
    obtenerTratamientos() {
        this.onStart();
        return this.http.get(this.getUrl(['obtener','tratamientos','categoria']))
            .then((response) => this.onData(response))
            .then((response) => this.onData(response))
            .catch(() => {
                throw new Error('Error al guardar los datos')
            })
            .finally(() => {
                this.onFinaly();
            })
    }
}


export class PortalLinea {
    constructor() {
        this.catalogoParentescos = []
        this.idCuenta = null
        this.idImagen = null
        this.idPlan = null
        this.idPlanPortal = []
        this.idsPlanBase = []
        this.numeroMaximo = null
        this.parentescos = []
        this.precioNeto = null
        this.tipoValidacion = null
        this.usuarioLogueado = null
    }


}

export class PrecioStripeDetalle {
    constructor() {
        this.idPrecioStripeDetalle = null
        this.idCargaCambioPrecioStripe = null
        this.idTicketStripe = null
        this.idCertificadoStripe = null
        this.subscripcion = null
        this.subscripcionItem = null
        this.idEstatusCarga = null
        this.mensajeError = null
        this.fechaInicioSubscripcion = null
        this.fechaAlta = null
        this.registroActivo = null
        this.resumen = null
    }
}
